// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"b2aea48f","453":"c7bd360d","806":"df54f434"}[chunkId] + ".chunk.js";
};